import { withLegalIntelSection } from '../../CourtCases/constants';
import { LegalIntelligenceIconChip } from '../components/LegalIntelligenceIconChip';

import {
  PopularSearchesGrid,
  PopularSearchesSectionRoot,
  PopularSearchesTitle,
  PopularSearchLinkLabel,
  PopularSearchToolLink,
} from './components';
import { TOOL_LINKS } from './constants';

export function LegalIntelligenceToolsSection() {
  return (
    <PopularSearchesSectionRoot
      component="section"
      aria-labelledby="legal-intelligence-popular-searches-heading"
    >
      <PopularSearchesTitle
        id="legal-intelligence-popular-searches-heading"
        component="h2"
        variant="h6"
      >
        Popular Searches
      </PopularSearchesTitle>
      <PopularSearchesGrid>
        {TOOL_LINKS.map(({ label, path, legalIntelSection, icon }, index) => (
          <PopularSearchToolLink
            key={`${label}-${path}`}
            to={withLegalIntelSection(path, legalIntelSection)}
            sx={(theme) =>
              index === TOOL_LINKS.length - 1 && TOOL_LINKS.length % 2 === 1
                ? {
                    gridColumn: { xs: '1 / -1', md: 'auto' },
                    justifySelf: { xs: 'center', md: 'stretch' },
                    width: {
                      xs: `calc((100% - ${theme.spacing(1.5)}) / 2)`,
                      sm: `calc((100% - ${theme.spacing(2)}) / 2)`,
                      md: 'auto',
                    },
                  }
                : {}
            }
          >
            <LegalIntelligenceIconChip aria-hidden>
              {icon}
            </LegalIntelligenceIconChip>
            <PopularSearchLinkLabel component="span" variant="subtitle2">
              {label}
            </PopularSearchLinkLabel>
          </PopularSearchToolLink>
        ))}
      </PopularSearchesGrid>
    </PopularSearchesSectionRoot>
  );
}
